module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[46]45.7cf0538.woff2";